import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.EditPaymentDetailsPopupContent.RemoveConfirmationPopupContent', {
    areYouSure: 'Are you sure you want to remove the payment details?',
    cancel: 'Cancel',
    submit: 'Yes, remove',
});
